import { ReactNode, useEffect } from "react";
import { type AccessPolicy } from "../../types";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

type AuthGuardProps = {
	/** Access rule. Defaults to accepting authenticated or booking users. */
	policy?: AccessPolicy;
	/** Path to redirect to when access is denied. */
	redirectTo: string;
	children: ReactNode;
};

export const AuthGuard = ({ policy = "authenticated", redirectTo, children }: AuthGuardProps) => {
	const { isAuthenticated, hasBooking } = useAuth();
	const navigate = useNavigate();

	const isAllowed = policy === "authenticated" ? isAuthenticated : isAuthenticated || hasBooking;

	useEffect(() => {
		if (!isAllowed) {
			navigate(redirectTo, { replace: true });
		}
	}, [isAllowed, redirectTo, navigate]);

	return isAllowed ? <>{children}</> : null;
};
